export default "__VITE_ASSET__Ba2YM6JC__"